var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40146 4.75953C7.89178 3.29902 9.89826 2.48566 11.9849 2.49619C14.0715 2.50673 16.0697 3.34032 17.5452 4.81581C19.0207 6.2913 19.8543 8.28946 19.8648 10.3761C19.8753 12.4627 19.062 14.4692 17.6015 15.9595L13.4155 20.1455C13.0404 20.5205 12.5318 20.7311 12.0015 20.7311C11.4711 20.7311 10.9625 20.5205 10.5875 20.1455L6.40146 15.9595C4.91635 14.4743 4.08203 12.4599 4.08203 10.3595C4.08203 8.25915 4.91635 6.24479 6.40146 4.75953Z",
    stroke: "#00ADEF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3594C13.6569 13.3594 15 12.0162 15 10.3594C15 8.70252 13.6569 7.35938 12 7.35938C10.3431 7.35938 9 8.70252 9 10.3594C9 12.0162 10.3431 13.3594 12 13.3594Z",
    stroke: "#00ADEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLocation);
export default __webpack_public_path__ + "static/media/newLocation.0aceb100ad5cb29f733dceb67f598a92.svg";
export { ForwardRef as ReactComponent };